import {
  TComponentValue,
} from '@/types/openapi-type.ts';

export enum EEquipmentPhysicalType {
  PIT = 1,
  PIT_RETORT = 2,
  BELL = 10,
  HORIZONTAL = 20,
  HORIZONTAL_RETORT = 21,
  BOX = 30,
  MULTI_CHAMBER = 40,
  ROTARY_HEARTH = 50,
  PUSHER = 51,
  RING_HEARTH = 52,
  BELT = 100,
  ROTARY_RETORT = 110,
  SHAKER_HEARTH = 120,
  STORAGE = 200,
  LOADING = 201,
  UNLOADING = 202,
  LOADING_UNLOADING = 203,
}

export const EquipmentPhysicalTypeMap: Record<TComponentValue<'EquipmentPhysicalType'>, keyof typeof EEquipmentPhysicalType> = {
  1: 'PIT',
  2: 'PIT_RETORT',
  10: 'BELL',
  20: 'HORIZONTAL',
  21: 'HORIZONTAL_RETORT',
  30: 'BOX',
  40: 'MULTI_CHAMBER',
  50: 'ROTARY_HEARTH',
  51: 'PUSHER',
  52: 'RING_HEARTH',
  100: 'BELT',
  110: 'ROTARY_RETORT',
  120: 'SHAKER_HEARTH',
  200: 'STORAGE',
  201: 'LOADING',
  202: 'UNLOADING',
  203: 'LOADING_UNLOADING',
};

// Categories mirror the physical-type numeric ranges defined in
// py_qmulus_core/qmulus/core/asset/_asset_with_properties/equipment_schema.py:
// 1-49 batch, 50-99 semi-continuous, 100-199 continuous, 200-end storage.
export enum EEquipmentPhysicalTypeCategory {
  BATCH_FURNACE = 'batchFurnace',
  SEMI_CONTINUOUS_FURNACE = 'semiContinuousFurnace',
  CONTINUOUS_FURNACE = 'continuousFurnace',
  STORAGE = 'storage',
}

export const EQUIPMENT_PHYSICAL_TYPE_CATEGORY_ORDER: EEquipmentPhysicalTypeCategory[] = [
  EEquipmentPhysicalTypeCategory.BATCH_FURNACE,
  EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE,
  EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE,
  EEquipmentPhysicalTypeCategory.STORAGE,
];

export const EquipmentPhysicalTypeCategoryMap: Record<EEquipmentPhysicalType, EEquipmentPhysicalTypeCategory> = {
  [EEquipmentPhysicalType.PIT]: EEquipmentPhysicalTypeCategory.BATCH_FURNACE,
  [EEquipmentPhysicalType.PIT_RETORT]: EEquipmentPhysicalTypeCategory.BATCH_FURNACE,
  [EEquipmentPhysicalType.BELL]: EEquipmentPhysicalTypeCategory.BATCH_FURNACE,
  [EEquipmentPhysicalType.HORIZONTAL]: EEquipmentPhysicalTypeCategory.BATCH_FURNACE,
  [EEquipmentPhysicalType.HORIZONTAL_RETORT]: EEquipmentPhysicalTypeCategory.BATCH_FURNACE,
  [EEquipmentPhysicalType.BOX]: EEquipmentPhysicalTypeCategory.BATCH_FURNACE,
  [EEquipmentPhysicalType.MULTI_CHAMBER]: EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE,
  [EEquipmentPhysicalType.ROTARY_HEARTH]: EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE,
  [EEquipmentPhysicalType.PUSHER]: EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE,
  [EEquipmentPhysicalType.RING_HEARTH]: EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE,
  [EEquipmentPhysicalType.BELT]: EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE,
  [EEquipmentPhysicalType.ROTARY_RETORT]: EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE,
  [EEquipmentPhysicalType.SHAKER_HEARTH]: EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE,
  [EEquipmentPhysicalType.STORAGE]: EEquipmentPhysicalTypeCategory.STORAGE,
  [EEquipmentPhysicalType.LOADING]: EEquipmentPhysicalTypeCategory.STORAGE,
  [EEquipmentPhysicalType.UNLOADING]: EEquipmentPhysicalTypeCategory.STORAGE,
  [EEquipmentPhysicalType.LOADING_UNLOADING]: EEquipmentPhysicalTypeCategory.STORAGE,
};
